/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

var isActiveItem = function isActiveItem(_ref, activeHref) {
  var active = _ref.active,
    to = _ref.to,
    href = _ref.href;
  // An instance where they've manually set the active prop
  if (typeof active === 'boolean') {
    return active;
  }
  // They're expecting the component to control the active prop.
  if ((to || href) === activeHref) {
    return true;
  }
  return false;
};

/**
 * Find the first active nav item in an array of items.
 * @param {*} items The array of items to search.
 * @param {*} activeHref The currently active href.s
 */
var _findActiveItem = function findActiveItem(items, activeHref) {
  return items.reduce(function (activeItem, item) {
    var nestedItems = item.items;
    if (activeItem) {
      return activeItem;
    }
    // Check nested items first, as anything with nested items do not have active, to, or href props.
    if (nestedItems) {
      return _findActiveItem(nestedItems, activeHref) || activeItem;
    }
    if (isActiveItem(item, activeHref)) {
      return item;
    }
    return activeItem;
  }, undefined);
};

export { _findActiveItem as findActiveItem, isActiveItem };
